<!-- eslint-disable -->
<template lang="pug">
    .carousel-container
        .scene-container(:class="{'scene-container--large': showingCouples.length <= 4}")
            .scene(@wheel="handleRotate($event)")
                .carousel
                    .carousel__cell(v-for='(couple, index) in showingCouples', :key="index")
                        .left-block
                            img.image(v-if="couple.left.type === 'image'", :src='couple.left.value | apiFile')
                            div.carousel__text-container(v-else)
                                | {{ couple.left.value }}
                        .right-block
                            img.image(v-if="!gameStarted && couple.right.type === 'image'" :src='couple.right.value | apiFile')
                            drop.drop-zone(
                                v-else-if="couple.right.type === 'dropZone' && showingCoupleIndex === index"
                                @drop="dropItemInRightReel(couple, $event)"
                            )
                                div.drop-zone__shake-zone
                            drag(
                                v-else-if="gameStarted && !isMobile && couple.right.type === 'image'",
                                :draggable="index === showingCoupleIndex",
                                :transfer-data="{ item: couple.right, index: activeCoupleIndex, from: 'right-column' }",
                                @dragstart="$emit('blockReelsScroll')",
                                @dragend="$emit('unlockReelsScroll')",
                                @touchmove="$emit('blockReelsScroll')"
                            )
                                img.image(:src='couple.right.value | apiFile')
                            div.right-block__tapped-image(
                                v-else-if="gameStarted && couple.right.type === 'image' && isMobile",
                                :class="activeCoupleIndex === index && 'right-block__tapped-image_pointer'"
                                :data-active-index="activeCoupleIndex",
                                :data-from="'right-column'",
                                :data-index="index"
                            )
                                img.image(:src='couple.right.value | apiFile')
                            div.carousel__input-container(
                                v-else-if="couple.right.type === 'textInput'",
                                :class="showingCoupleIndex === index && 'carousel__input-container_white'"
                            )
                                textarea.carousel__text-input(
                                    v-model="couple.right.value",
                                    :placeholder="$i18n.t('trainer.trainer_gamePlayBox_answer')",
                                    :disabled="showingCoupleIndex !== index"
                                    v-autosize=""
                                )
                            div.carousel__text-container(
                                v-else-if="couple.right.type === 'word' || couple.right.type === 'phrase'"
                                :class="couple.right.helpMarker && 'carousel__text-container_help-marker'"
                            )
                                | {{ couple.right.value }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import { Drag, Drop } from 'vue-drag-drop';
    const RADIUS = 3;
    const DEFAULT_VOLUME = 0.6;
    const MAX_AMOUNT_OF_COUPLES = 13;
    const BOUNDARY = 6;

    export default {
        props: {
            couples: {
                type: Array,
                default: () => []
            },
            showFieldsForAnswers: Boolean,
            gameStarted: Boolean,
            mode: String,
            dragStarted: Boolean,
            disableReplyButton: Boolean,
            typeOfRightColumn: String,
            blockReelsScroll: {
                type: Boolean,
                default: false
            },
            isMobile: Boolean,
            rotateButtonClicked: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                carousel: null,
                cellWidth: 0,
                cellHeight: 0,
                indexForRotate: 0,
                radius: 0,
                theta: 0,
                cells: null,
                startGame: false,
                activeCoupleIndex: 0,
                directionOfCounting: true,
                soundInstance: null,
                showingCoupleIndex: 0
            }
        },
        watch: {
            showFieldsForAnswers () {
                if (this.mode === 'inTurn' && !this.gameStarted) {
                    if (this.indexForRotate < this.couples.length - 1) {
                        (this.indexForRotate === this.couples.length - 2) && this.$emit('showPlayButton');
                        this.showNewPair();
                    } else {
                        for (let i = 0; i < this.cells.length; i++) {
                            this.cells[i].style.opacity = 1 ;
                        }
                    }
                }
            },
            indexForRotate (value) {
                if (this.inputInActiveCell) {
                    this.inputInActiveCell.blur();
                }
                this.directionOfCounting = value >= 0;
                this.activeCoupleIndex = !this.directionOfCounting && (Math.abs(value) % this.couples.length)
                        ? this.couples.length - Math.abs(value) % this.couples.length
                        : Math.abs(value) % this.couples.length;
                this.showingCoupleIndex = !this.directionOfCounting && (Math.abs(value) % this.amountOfPairs)
                        ? this.amountOfPairs - Math.abs(value) % this.amountOfPairs
                        : Math.abs(value) % this.amountOfPairs;
                if (this.inputInActiveCell) {
                    this.$nextTick(() => {
                        this.inputInActiveCell.focus();
                    });
                }
            },
            dragStarted (value) {
                let shakeZone = document.querySelector('.drop-zone__shake-zone');
                this.cells[this.showingCoupleIndex].style.border = value && shakeZone ? "4px rgb(142, 193, 98) solid" : "";
                if (value && shakeZone) {
                    shakeZone.classList.add('shake');
                    setTimeout(() => {
                        shakeZone.classList.remove('shake');
                    }, 1000)
                }
            },
            rotateButtonClicked (newValue, oldValue) {
                if (newValue && !oldValue) {
                    this.indexForRotate++;
                    this.playScroll();
                    this.rotateCarousel();
                }
            }
        },
        mounted () {
            this.carousel = document.querySelector('.carousel');
            document.addEventListener('keydown', _.throttle(event => {
                if (this.mode === 'inTurn' && !this.gameStarted) {
                    return;
                }
                if (event.keyCode === 40) {
                    this.indexForRotate++;
                    this.playScroll();
                    this.rotateCarousel();
                } else if (event.keyCode === 38) {
                    this.indexForRotate--;
                    this.playScroll();
                    this.rotateCarousel();
                }
            }, 300));
            if (this.typeOfRightColumn !== 'image' && this.gameStarted) {
                this.addEventListenerOnInputs();
            }
            this.amountOfPairs = this.showingCouples.length;
            this.cells = document.querySelectorAll('.carousel__cell');
            this.cellWidth = this.carousel.offsetWidth;
            this.cellHeight = this.carousel.offsetHeight;
            this.startCarousel();
            this.addScroll();
        },
        beforeDestroy () {
            document.removeEventListener('keydown', this.rotateCarousel);
        },
        computed: {
            coupleDataInActiveCell () {
                if (this.typeOfRightColumn === 'image') {
                    return this.showingCouples[this.showingCoupleIndex].right;
                }
                return null;
            },
            inputInActiveCell () {
                if (this.typeOfRightColumn !== 'image') {
                    return this.cells[this.showingCoupleIndex].children[1].children[0].children[0];
                }
                return null;
            },
            showingCouples () {
                if (this.couples.length > MAX_AMOUNT_OF_COUPLES) {
                    let couples = [];
                    if (this.activeCoupleIndex - BOUNDARY < 0) {
                        let diff = this.activeCoupleIndex - BOUNDARY;
                        couples = this.couples.slice(this.activeCoupleIndex, this.activeCoupleIndex + BOUNDARY + 1);
                        couples = couples.concat(this.couples.slice(diff));
                        couples = couples.concat(this.couples.slice(0, this.activeCoupleIndex));
                    } else if (this.activeCoupleIndex + BOUNDARY + 1 >= this.couples.length) {
                        let diff = this.activeCoupleIndex + BOUNDARY + 1 - this.couples.length;
                        couples = this.couples.slice(this.activeCoupleIndex);
                        couples = couples.concat(this.couples.slice(0, diff));
                        couples = couples.concat(this.couples.slice(this.activeCoupleIndex - BOUNDARY, this.activeCoupleIndex));
                    } else {
                        couples = this.couples.slice(this.activeCoupleIndex, this.activeCoupleIndex + BOUNDARY + 1);
                        couples = couples.concat(this.couples.slice(this.activeCoupleIndex - BOUNDARY, this.activeCoupleIndex));
                    }
                    return this.showingCoupleIndex ? couples.splice(-this.showingCoupleIndex).concat(couples) : couples;
                }
                return this.couples;
            }
        },
        methods: {
            rotateCarousel () {
                const angle = this.theta * this.indexForRotate * -1;
                this.carousel.style.transform = 'translateZ(' + -this.radius + 'px) rotateX(' + angle + 'deg)';
                this.$emit('endCarouselRotate');
            },
            handleRotate (event) {
                if (this.mode === 'inTurn' && !this.gameStarted) {
                    return;
                }
                if (!this.blockReelsScroll) {
                    event.deltaY < 0 ? this.indexForRotate-- : this.indexForRotate++;
                    this.playScroll();
                    this.rotateCarousel();
                }
                this.$emit('unlockReelsScroll');
            },
            playScroll () {
                this.soundInstance = this.$createjs.Sound.play("couplesScroll");
                this.soundInstance.volume = DEFAULT_VOLUME;
            },
            startCarousel () {
                this.theta = 360 / this.showingCouples.length;
                this.radius = this.showingCouples.length > 2
                        ? Math.round( ( this.cellHeight / 2) / Math.tan( Math.PI / this.showingCouples.length ) )
                        : RADIUS;
                for (let i = 0; i < this.cells.length; i++) {
                    if (!this.gameStarted && this.mode === 'inTurn' && i > 0) {
                        this.cells[i].style.opacity = 0;
                    }
                    this.cells[i].style.transform = 'rotateX(' + this.theta * i + 'deg) translateZ(' + this.radius + 'px)';
                }
                this.soundInstance = this.$createjs.Sound.play("couplesReels");
                this.soundInstance.volume = DEFAULT_VOLUME;
                if (this.inputInActiveCell) {
                    this.inputInActiveCell.focus();
                }
                this.rotateCarousel();
            },
            showNewPair () {
                this.cells[this.showingCoupleIndex].style.opacity = 0;
                this.indexForRotate++;
                this.$nextTick(() => {
                    this.cells[this.showingCoupleIndex].style.opacity = 1;
                    this.playScroll();
                    this.rotateCarousel();
                });
            },
            addScroll () {
                let mc = new Hammer.Manager(this.carousel);
                mc.add(new Hammer.Swipe({
                    event: 'swipe',
                    pointers: 1,
                    threshold: 0,
                    direction: Hammer.DIRECTION_VERTICAL,
                    velocity: 0.3
                }));
                mc.on('swipe', _.throttle(event => this.handleRotate(event), 500));
            },
            addDoubleTapListener () {
                let cells = document.getElementsByClassName('right-block__tapped-image');
                if (cells.length) {
                    for (let i = 0; i < cells.length; i++) {
                        let mc = new Hammer.Manager(cells[i]);
                        mc.add( new Hammer.Tap({ event: 'doubletap', taps: 2 }) );
                        mc.on('doubletap', _.throttle(event => this.handleDoubleTappedImage(event), 500));
                    }
                }
            },
            dropItemInRightReel (couple, data) {
                if (data && data.from !== 'right-column') {
                    this.soundInstance = this.$createjs.Sound.play("couplesDrop");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                    couple.right = _.cloneDeep(data.item);
                    this.$emit('dropItemInRightReel', data.index);
                    this.rotateCarouserAfterAnswer();
                    this.$nextTick(() => {
                        if (this.typeOfRightColumn === 'image') {
                            this.addDoubleTapListener();
                        }
                    });
                }
            },
            addEventListenerOnInputs () {
                let inputs = document.getElementsByClassName('carousel__text-input');
                for (let i = 0; i < inputs.length; i++) {
                    inputs[i].addEventListener('keydown', event => {
                        if (event.keyCode === 13 && _.trim(inputs[i].value)) {
                            this.rotateCarouserAfterAnswer();
                        }
                    })
                }
            },
            rotateCarouserAfterAnswer () {
                this.$nextTick(() => {
                    if (this.disableReplyButton) {
                        this.indexForRotate--;
                        this.playScroll();
                        this.rotateCarousel();
                    } else {
                        this.$emit('addFocusOnReplyButton');
                    }
                })
            },
            returnImageToAnswersBox (transferData) {
                this.$emit('dropItemInAnswersBox', transferData);
            },
            handleDoubleTappedImage (event) {
                let dataSet = event.target.dataset;
                let item = _.cloneDeep(this.coupleDataInActiveCell);
                if (dataSet.index === dataSet.activeIndex && item.type === 'image') {
                    let transferData = {
                        index: dataSet.activeIndex,
                        from: dataSet.from,
                        item: item,
                    };
                    this.returnImageToAnswersBox(transferData);
                }
            },
        },
        components: {
            Drag,
            Drop
        }
    }
</script>

<style lang="scss" scoped>
    .carousel-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .scene {
        width: 100%;
        height: 100%;
        text-align: center;
        perspective: 500px;
        margin: 0 auto;
    }

    .carousel {
        width: 100%;
        height: 100%;
        white-space: nowrap;
        position: absolute;
        transform: translateZ(-288px);
        transform-style: preserve-3d;
        transition: transform 0.3s;
    }

    .carousel__text-input {
        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border: 0 solid #E6E6F8;
        border-bottom-width: 1px;

        font-weight: normal;

        padding: 10px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            position: relative;
            bottom: 0;
            color: #BDBDBD;
        }

        align-items: center;
        max-height: calc(2.25em + 20px);
        height: calc(1.4em + 20px);
        justify-content: flex-end;
        position: relative;
        vertical-align: bottom;
        background-color: transparent;
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;

        overflow: hidden !important;
        overflow-wrap: break-word;

        margin-bottom: 0;
        font-size: 20px;
        line-height: 24px;
        text-align: center;

        @include media($sm) {
            font-size: 26px;
            line-height: 31px;
        }

        @include media($md) {
            font-size: 32px;
            line-height: 38px;
        }

        @include media($lg) {
            font-size: 38px;
            line-height: 45px;
        }
    }

    .carousel__text-container {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        overflow-wrap: break-word;
        white-space: normal;
        background: white;
    }

    .carousel__input-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        background: $hsl-color-gray-98;
    }

    .carousel__input-container_white {
        background: white;
    }

    .carousel__text-container_help-marker {
        border: 2px solid #ffc70f !important;
    }

    .left-block, .right-block {
        background: $x-color-white;
        width: calc(100% / 2);
        background: $x-color-white;
        border: 2px solid #F5F5F5;
        height: 100%;
        display: inline-block;
        box-sizing: border-box;
    }

    .right-block {
        background: $hsl-color-gray-98;
        border: 2px solid #E6E6F8;
    }

    .right-block__tapped-image_pointer {
        cursor: pointer;
    }

    .carousel__cell {
        position: absolute;
        width: 100%;
        height: 100%;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-black;
        background-color: $x-color-white;
        text-align: center;
        transition: transform 1s, opacity 1s;
        user-select: none;
        display: flex;
        word-break: break-word;
        @include media($sm) {
            font-size: 28px;
            line-height: 33px;
        }
        @include media($md) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($lg) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .image, .text {
        pointer-events: none;
        user-select: none;
    }

    .image {
        height: 100%;
        width: 100%;
        max-height: 100%;
        margin: auto;
    }

    .scene-container {
        display: inline-block;
        width: 310px;
        height: 160px;
        @include media($sm) {
            width: 254px;
            height: 127px;
        }
        @include media($md) {
            width: 330px;
            height: 165px;
        }
        @include media($lg) {
            width: 400px;
            height: 200px;
        }
    }

    .scene-container--large {
        @include media($sm) {
            width: 410px;
            height: 210px;
        }
        @include media($md) {
            width: 500px;
            height: 260px;
        }
        @include media($lg) {
            width: 660px;
            height: 300px;
        }
        @include media($xlg) {
            width: 540px;
            height: 280px;
        }
        @include media($xl) {
            width: 660px;
            height: 340px;
        }
        @include media($xxl) {
            width: 780px;
            height: 400px;
        }
    }
    .drop-zone {
        width: 100%;
        height: 100%;
        display: flex;
        background: $hsl-color-gray-98;
    }

    .drop-zone__shake-zone {
        width: 100%;
        height: 100%;
        margin: auto;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
